"use client"

import { PRIMARY_COLOR } from "@/assets/static/colors"
import styles from "./global_error.module.scss"

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const errorId =
        error.digest || Math.random().toString(16).slice(2, 10).toUpperCase()
    const timestamp = new Date().toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    })

    return (
        <html lang="en">
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content={PRIMARY_COLOR} />
                <title>Critical Error — Emran Hejazi</title>
            </head>
            <body className={styles.body}>
                <div className={styles.page}>
                    <div className={styles.glow} />
                    <div className={styles.pattern} />

                    <div className={styles.card}>
                        <div className={styles.symbol}>
                            <div className={styles.x_mark} />
                        </div>

                        <p className={styles.header}>Panic Report</p>

                        <div className={styles.divider} />

                        <p className={styles.message}>
                            A <strong>critical system error</strong> has occurred.
                            <br />
                            The application encountered an unrecoverable state
                            and cannot continue.
                        </p>

                        <div className={styles.details}>
                            <div className={styles.detail_row}>
                                <span>ERROR</span>
                                <span>0x{errorId}</span>
                            </div>
                            <div className={styles.detail_row}>
                                <span>TIME</span>
                                <span>{timestamp}</span>
                            </div>
                        </div>

                        <button
                            className={styles.restart_button}
                            onClick={() => reset()}
                            type="button"
                        >
                            Restart Application
                        </button>
                    </div>
                </div>
            </body>
        </html>
    )
}
